import axios from "axios";
import { Capacitor } from '@capacitor/core';
import { CapacitorHttp } from '@capacitor/core';

class StrHttpClient {

  get(url, parameters) {
    if (Capacitor.isNativePlatform()) {
      const options = {
        url: url,
      };
      return CapacitorHttp.get(options);
    } else {
      return axios.create({
        baseURL: url
      }).get(url, parameters);
    }
  }

}

export default new StrHttpClient();